export function calculateTotalWeight(equipment) {


    let total = 0.0

    equipment.forEach(item => {
        const quantity = parseInt(item.quantity)
        const weight = parseFloat(item.itemWeightInLbs)

        if(quantity && weight) {
            const totalWeight = quantity * weight
            total += totalWeight
        }
    })


    return total.toFixed(2)
}